/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

this.bellafill = this.bellafill || {};
bellafill.breakpoints = {
     xs: 0,
     sm: 576,
     md: 768,
     lg: 992,
     xl: 1200
   };
bellafill.largerThan = function(breakpoint) {
     return window.outerWidth > breakpoint;
   };
bellafill.ajax_url = jQuery('body').data('ajaxUrl');
bellafill.disclaimersVisible = Cookies.get('disclaimersVisible');

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.hamburger').on('click', function(){
          $(this).add('.nav-mobile').toggleClass('is-active');
          $('body').toggleClass('mobile-nav-open');
        });
        $('.nav-collapse > a').on('click', function(event) {
          event.stopPropagation();
          event.preventDefault();
          $(this).parent().toggleClass('is-active');
        });
        $('.nav-collapse .menu-item-type-custom a').on('click', function(event) {
          // Collapse the nav on custom links just in case link is to an anchor
          // tag on the current page. To do: target hash links specifically.
          $('.hamburger').add('.nav-mobile').toggleClass('is-active');
          $('body').toggleClass('mobile-nav-open');
          $(this).parent('.nav-collapse').toggleClass('is-active');
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Function to toggle an expandable component
        function toggleExpand($this, setCookie) {
          var toggleClassName = $this.data('toggleClassName') ? $this.data('toggleClassName') : 'fa-plus-circle fa-minus-circle';
          $this.toggleClass('expanded');
          $this.next().toggleClass('expanded').attr('aria-expanded', function (i, attr) {
            return attr === 'true' ? 'false' : 'true';
          });
          $this.find('i').toggleClass(toggleClassName);

          // Toggle the Disclaimers Footer cookie if necessary
          if (setCookie) {
            var disclaimersVisible = ($this.hasClass('expanded') ? true : false);
            Cookies.set('disclaimersVisible', disclaimersVisible);
          }
        }

        // Set the initial state of Disclaimers Footer based on cookie
        if (bellafill.disclaimersVisible === 'false') {
          var disclaimers = $('.disclaimers-cookie');
          toggleExpand(disclaimers, false);
        }

        // Click event on an expandable component
        $('.expandable .head').on('click', function() {
          var $this = $(this),
              windowWidth = $(window).width(),
              isMobile = windowWidth < bellafill.breakpoints.md ? true : false,
              setCookie = $this.hasClass('disclaimers-cookie') ? true : false;
          if ((!isMobile && !($this.parents('.collapse-mobile').length)) || (isMobile)){
            toggleExpand($this, setCookie);
          }
        });
        /* BLOG AND NEWS */

        // Ajax update category filter

        function updateCategoryFilter(offset, postperpage, post_type) {

          options = {
                action: 'ajax_get_categories',
                posts_per_page: offset * postperpage,
                post_types:  post_type
            };

            $.ajax({
                  url: bellafill.ajax_url,
                  data: options,
                  method: 'POST',
                  success: function(i) {
                    // update the category filter
                    var
                      $filterList = $('.filter-list'),
                      $filterListItems = $filterList.find('li')
                    ;
                    if(i.result) {
                      // apply template to each result
                      $('.filter-list li[data-category]').remove();
                      for(var key in i.result) {
                        if(i.result.hasOwnProperty(key)) {
                          $filterList.append('<li data-category="'+ key + '"><a href="#' + key + '">' + i.result[key] + '</a></li>');
                        }
                      }
                      if($('.filter-list li').length > 2) {
                        $filterList.addClass('d-block').removeClass('d-none');
                      } else {
                        $filterList.removeClass('d-block').addClass('d-none');
                      }
                    }
                  },
                  error: function(e, i, t) {
                    console.log(e);
                    console.log(i);
                    console.log(t);
                  }
            });
        }
        // Ajax Load More
        // handlebars template:
        var postPreviewTemplate = bellafill.templates.postPreview;
        $('.ajax-load-more').on('click', function(event) {
            // set vars
            event.preventDefault();
            var $this = $(this),
            maxPages = parseInt($(this).data('max-pages'), 10);
            options = {
                  action: 'ajax_get_posts',
                  posts_per_page: $this.data('posts-per-page') ? $this.data('posts-per-page') : '9',
                  offset: $this.data('offset'),
                  post_types:  $this.data('post-type') ? $this.data('post-type') : 'posts'
              };

            $.ajax({
                  url: bellafill.ajax_url,
                  data: options,
                  method: 'POST',
                  success: function(i) {
                    if(i.result) {
                      // apply template to each result
                      for (var key in i.result) {
                        var post = {
                          'title': i.result[key].title,
                          'cat-slug': i.result[key].category.slug,
                          'datetime': i.result[key].datetime,
                          'date': i.result[key].date,
                          'cat': i.result[key].category.name,
                          'link': i.result[key].link,
                          'excerpt': i.result[key].excerpt
                        };
                        $('#ajax-target').append(postPreviewTemplate(post));
                      }
                      // then, update the offset and settings.
                      // adjust offset for subsequent ajax calls
                      var
                        offset = options.offset + options.posts_per_page,
                        currPage = $this.data('current-page'),
                        updatedPage = parseInt(currPage, 10) + 1
                      ;
                      $this.data('offset', options.offset + options.posts_per_page);
                      $this.data('current-page', updatedPage);

                      // update the category filter
                      updateCategoryFilter(updatedPage, parseInt(options.posts_per_page, 10), options.post_types);

                      if($this.data('current-page') >= maxPages) {
                        $this.hide();
                      }
                    } else {
                      // hide button
                      $this.hide();
                    }
                  },
                  error: function(e, i, t) {
                    console.log(e);
                    console.log(i);
                    console.log(t);
                  }
              });
        });
        // Filter
        $('ul.filter-list').on('click', 'li a', function(event) {
          event.preventDefault();
          var val = $(this).attr('href');
          $('.post-index .article-container').show();
          if(val !== "#all") {
            $('.post-index .article-container').not('[data-category="' + val.split('#')[1] + '"]').hide();
            $('.ajax-load-more').hide();
          } else {
            $('.ajax-load-more').show();
          }
          $('#active-filter').html('').append(val.split('#')[1]);
          $('ul.filter-list li').removeClass('active');
          $(this).parent().addClass('active');
        });


        // select toggles hidden input
        $('select.toggler').change(function() {
          var
            id = $(this).val();
            fields = $(this).data('toggle').split(',')
          ;
          // set each field to 0 first
          for (var field in fields) {
            $('#' + fields[field]).val('0');
          }
          // set the hidden input value to 1.
          $('#'+id).val('1');
        });

        // form validation method - no empty select
        // add the rule here
        $.validator.addMethod("valueNotEquals", function(value, element, arg){
          return arg !== value;
        }, "Value must not equal arg.");

        $.validator.addMethod("customEmail", function(value, element) {
          return this.optional( element ) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( value );
        }, "Please enter a valid email address.");

        $('form.validate').validate({
          onkeyup: false,
          onfocusout: function(element) {
            // trim whitespace
            element.value = $.trim(element.value);

            var
              $currField = $(element),
              wasInvalid = false
            ;

            if (($currField).hasClass('error')) {
              wasInvalid = true;
            }

            // re-validate field
            this.element( element );

            if (($currField).hasClass('valid') && wasInvalid) {
              $currField.addClass('corrected');
            }
            else {
              $currField.removeClass('corrected');
            }
          },
          submitHandler: function(form) {
            if ($(form).valid()) {
              form.submit();
            }
            return false;
          },
          rules: {
            email: { customEmail: true },
            userType: { valueNotEquals: "" }
          },
          invalidHandler: function() {
            console.log('Invalid Form!');
          },
          errorPlacement: function(error, element) {
            if($(element).closest('form').hasClass('sign-up')) {
              error.insertAfter('#sign-up-input-wrapper');
            } else {
              error.insertAfter(element);
            }
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');

    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // Image sliders
  if($('.image-slider').length) {
    $('.image-slider').twentytwenty({
      no_overlay: true //Do not show the overlay with before and after
    });
  }

  // Carousel
  if($('.carousel').length) {
    $('.carousel').slick();
  }

  $('.video-modal').on('show.bs.modal', function() {
    var
      $iframe = $(this).find('iframe'),
      embed = $iframe.data('src')
    ;

    $iframe.attr('src', embed);
  });

  // Stop video on modal close
  $('body').on('hidden.bs.modal', '.video-modal', function () {
    var $iframe = $(this).find('iframe');
    $iframe.attr('src', '');
  });

  // Anchor nav scroll
  $('.anchor-nav a').on('click', function(e){
    e.preventDefault();
    var
      hash = this.hash,
      $target = $(hash),
      location = window.location.href.split('#')[0] // remove any current hash from url
    ;

    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top
      }, 600, function() {
        // add new hash to URL
        window.location.href = location + hash;
      });
    }
  });

})(jQuery); // Fully reference jQuery after this point.

// iframe business
var iframe_id="destination-frame"; // replace with id of the iframe to dynamically resize
var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

function autoResize(newheight, newwidth) {
  document.getElementById(iframe_id).style.height= parseInt(newheight) + 40 + "px";
}

eventer(messageEvent,function(e) {
  if( typeof(e.data) === 'string' && e.data.indexOf("w2gi:iframeHeightUpdated") !== -1 ) {
    var dimensions = e.data.split("//");
    autoResize(dimensions[1], dimensions[2]);
    }
    if( typeof(e.data) === 'string' && e.data.indexOf("w2gi:scrollPage") !== -1) {
      var offsets = document.getElementById(iframe_id).getBoundingClientRect();
      var values = e.data.split("//");
      var destination = values[1];
      var offset = values[2];
      window.scrollTo(0, destination + offsets.top);
    }
  },false);
